import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import FiltersNotFoundArt from "./assets/filters-not-found.png";
import NotFoundArt from "./assets/not-found.png";
import type { ListingContainerEmptyStateType, ListingContainerEmptyStateVariant } from "./listing-container.types";
const DEFAULT_MESSAGE = "نتیجه‌ای یافت نشد.";
const artByVariant: Record<ListingContainerEmptyStateVariant, string> = {
  "filters-not-found": FiltersNotFoundArt.src,
  "not-found": NotFoundArt.src
};
const getDefaultActionIcon = (variant: ListingContainerEmptyStateVariant) => variant === "filters-not-found" ? <MaterialIcon name="delete_outline" /> : null;
export function ListingEmptyState(t0) {
  const $ = _c(24);
  const {
    actionIcon,
    actionTitle,
    caption,
    className: t1,
    message: t2,
    onActionClick,
    variant
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const message = t2 === undefined ? DEFAULT_MESSAGE : t2;
  let t3;
  if ($[0] !== actionIcon || $[1] !== variant) {
    t3 = actionIcon === undefined ? getDefaultActionIcon(variant) : actionIcon;
    $[0] = actionIcon;
    $[1] = variant;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const resolvedActionIcon = t3;
  const t4 = `col-span-full flex min-h-[363px] w-full items-center justify-center ${className}`;
  const t5 = typeof message === "string" ? message : DEFAULT_MESSAGE;
  const t6 = artByVariant[variant];
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = <img alt={t5} className="h-[104px] w-[98px] object-contain" loading="eager" src={t6} />;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== message) {
    t8 = <div className="text-subtitle-1 text-on-surface-high-emphasis font-medium">{message}</div>;
    $[6] = message;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== caption) {
    t9 = caption && <div className="text-caption text-on-surface-medium-emphasis leading-6">{caption}</div>;
    $[8] = caption;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <div className="flex flex-col items-center gap-2">{t8}{t9}</div>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== actionTitle || $[14] !== onActionClick || $[15] !== resolvedActionIcon) {
    t11 = actionTitle && onActionClick && <Button StartIcon={resolvedActionIcon} className="!text-subtitle-1 !h-10 !rounded-[8px] !font-medium" color="secondary" onClick={onActionClick} variant="outline">{actionTitle}</Button>;
    $[13] = actionTitle;
    $[14] = onActionClick;
    $[15] = resolvedActionIcon;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t7) {
    t12 = <div className="flex w-full max-w-[360px] flex-col items-center gap-5 px-4 py-10 text-center">{t7}{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t4) {
    t13 = <div className={t4}>{t12}</div>;
    $[21] = t12;
    $[22] = t4;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}